import { reqDelete, reqGet, reqPatch, reqPost } from './index';

export const fetchFloorList = param => reqGet('/v3/api/common/floor', { ...param, isAll: 'Y' });
export const fetchSelectedFloorInfo = param => reqGet(`/v3/api/common/floor/${param.floorId}`, { ...param });
export const fetchGeofenceList = param => reqGet('/v3/api/common/geofence', { ...param, isAll: 'Y' });
//북마크 여부
export const fetchBookmarkList = param => reqGet('/v3/api/common/target/bookmark', { ...param, isAll: 'Y' });

//북마크 등록
export const createBookmarkApi = param => reqPost(`/v3/api/common/target/bookmark`, param);
//북마크 삭제
export const deleteBookmarkApi = param => reqDelete(`/v3/api/common/target/bookmark/${param.targetNum}`);

//대상 카테고리 속성 정보 목록조회 API
export const getCategoryPropertiesListApi = param =>
    reqGet('/v3/api/common/target/category/config', { ...param, isAll: 'Y' });

export const getUserInfoApi = param => reqGet('/v3/api/common/user/info/list', { ...param });

// 개인설정 업데이트
export const updateUserSetting = param => reqPatch('/v3/api/common/user/personal/config', { ...param });

// 개인설정 조회
export const fetchUserSetting = param => reqGet('/v3/api/common/user/personal/config', { ...param });
